// Shared helpers for showing who released a Sales Order and how Admin approved it.

// Who released (created) the Sales Order. Older records have no createdBy, so fall back to the audit log.
export const getReleasedBy = (so) => {
  if (!so) return { name: '', role: '', at: null };
  if (so.releasedByName) {
    return { name: so.releasedByName, role: '', at: so.releasedAt };
  }
  if (so.createdByName || so.createdBy?.name) {
    return { name: so.createdByName || so.createdBy?.name, role: so.createdByRole || so.createdBy?.role || '', at: so.releasedAt || so.createdAt };
  }
  const logs = so.auditLogs || [];
  const created = logs.find(a => a.action === 'created') || logs[0];
  if (created) {
    return { name: created.changedByName || created.changedBy?.name || '', role: created.changedByRole || '', at: created.changedAt };
  }
  return { name: so.salesPersonName || so.assignedTo?.name || '', role: '', at: so.createdAt };
};

export const formatPaymentBasis = (rec) => {
  if (!rec?.paymentType) return '';
  if (rec.paymentType === 'advance') {
    return `Advance${rec.advanceAmount ? ` ₹${Number(rec.advanceAmount).toLocaleString('en-IN')}` : ''}`;
  }
  return `Credit ${rec.creditDays || 0} days`;
};

export const formatRole = (role) => (role ? role.replace(/_/g, ' ') : '');

export const formatDateTime = (d) => (d ? new Date(d).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' }) : '');
